export const AVATAR_MAX_SIZE_MB = 3;
export const AVATAR_MAX_DIMENSION_PX = 4096;
export const AVATAR_CROP_IMAGE_TYPE = 'image/jpeg';
export const AVATAR_CROP_IMAGE_QUALITY = 0.85;
export const ACCEPTED_AVATAR_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif'];

export const getAvatarFileValidationError = (file: File): 'fileType' | 'fileSize' | null => {
    if (!ACCEPTED_AVATAR_IMAGE_TYPES.includes(file.type)) {
        return 'fileType';
    }

    if (file.size > AVATAR_MAX_SIZE_MB * 1024 * 1024) {
        return 'fileSize';
    }

    return null;
};

export const readFileAsDataUrl = (file: File) =>
    new Promise<string>((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result);
                return;
            }

            reject(new Error('Invalid file data'));
        };
        reader.onerror = () => reject(reader.error ?? new Error('Failed to read file'));
        reader.readAsDataURL(file);
    });

export const getImageDimensions = (src: string) =>
    new Promise<{ width: number; height: number }>((resolve, reject) => {
        const image = new Image();

        image.onload = () => resolve({ width: image.naturalWidth, height: image.naturalHeight });
        image.onerror = () => reject(new Error('Failed to load image'));
        image.src = src;
    });

export const canvasToAvatarFile = (canvas: HTMLCanvasElement) =>
    new Promise<File>((resolve, reject) => {
        canvas.toBlob(
            (blob) => {
                if (!blob) {
                    reject(new Error('Failed to crop image'));
                    return;
                }

                resolve(new File([blob], 'avatar.jpg', { type: AVATAR_CROP_IMAGE_TYPE }));
            },
            AVATAR_CROP_IMAGE_TYPE,
            AVATAR_CROP_IMAGE_QUALITY
        );
    });
